module.exports = __webpack_public_path__ + "static/media/blog2_pic7.3265dbcd.png";